import { render } from "./TokenLabel.vue?vue&type=template&id=29bbbbbb&scoped=true"
const script = {}

import "./TokenLabel.vue?vue&type=style&index=0&id=29bbbbbb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29bbbbbb"]])

export default __exports__